import { getLoadingBarTpl } from '../../model/tpl/loadingbar';
import { getDatasWithOption } from '../../utils/service';
import { isObject, truthy, parseStrIntToInt } from '../../utils/util';
import { BOARD } from '../../model/msg/board';

class ClassRanking {
  constructor(options) {
    const _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      serverId: 1,
      classCode: 'all',
      pageIndex: 1,
      clickPageBtnCallback: null,
      global: window
    }, options);

    _.wrap = $(_.option.wrap);

    _.currentPage = 1;

    _.msg = {
      NO_ITEM: '랭킹 정보가 없습니다.',
      NO_SUPPORT: '랭킹 정보를 제공하지 않는 서버입니다.'
    };
  }

  init() {
    const _ = this;

    if (_.wrap.length) {
      _.currentPage = (_.option.pageIndex >= 1) ? _.option.pageIndex : 1;

      if (_.option.serverId == 100 || _.option.serverId == 200 || _.option.serverId == 201 ) {
        _.setLoadingBar(false);
        _.displayError('NO_SUPPORT');
        return;
      } else {
        _.setLoadingBar(true);
        _.setData();
      }

    }

    return _;
  }

  setData() {
    const _ = this;



    getDatasWithOption([{
      type: 'GET',
      url: `${_.option.apiDomain}/api/world/ranking/${_.option.serverId}/${_.option.classCode}/list`,
      dataType: 'json',
      data: {
        page: _.currentPage
      }

    }], (data) => {
      _.setLoadingBar(false);
      _.setInstance(data);

    }, (data) => {
      _.setLoadingBar(false);

      if (data.responseJSON.result.errorCode === 'WORLD_RANK_NOT_EXIST_RANKING_SERVER') {
        _.displayError('NO_SUPPORT');

      } else {
        _.displayError('RETRY_LATER');
      }
    });
  }

  setInstance(data) {
    const _ = this;

    _.setDate(data.rankCachedTime);
    _.setList(data);
  }

  setDate(rankCachedTime) {
    $('header .date', this.wrap).text(rankCachedTime || '');
  }

  setList(data) {
    const _ = this;

    if (!data || !Array.isArray(data.rankList) || data.rankList.length <= 0) {
      _.displayError('NO_ITEM');
      return;
    }

    let tpl = '', rankChangeObj = null;
    data.rankList.forEach(function (value, index, array) {
      rankChangeObj = _.getRankChangeObj(value.rankChange);

      tpl += _.getRankItemTpl({
        rank: value.rank,
        serverRank: value.serverRank,
        rankChange: rankChangeObj.change,
        rankUpDown: rankChangeObj.updown,
        characterName: value.characterName,
        className: value.className,
        grade: parseStrIntToInt(value.grade)
      });
    });

    $('.table-list tbody', _.wrap).empty().append(tpl);

    _.setPagination(data.pagination);

    _.currentPage = data.pagination.currentPage;
  }

  setPagination(data) {
    const _ = this,
      tpl = _.getPaginationTpl(data);

    $('.pagination', _.wrap).empty().append(tpl);

    $('.btn.prev', _.wrap).on('click', function (evt) {
      const pageIndex = (_.currentPage < 1) ? 1 : _.currentPage - 1;
      _.option.clickPageBtnCallback.apply(null, [pageIndex]);
    });

    $('.btn.next', _.wrap).on('click', function (evt) {
      const pageIndex = (_.currentPage >= data.maxPageNo) ? data.maxPageNo : _.currentPage + 1;
      _.option.clickPageBtnCallback.apply(null, [pageIndex]);
    });
  }

  getRankItemTpl(data) {
    const _ = this;
    const gradeIcon = (parseStrIntToInt(data.serverRank) <= 3 && parseStrIntToInt(data.serverRank) > 0) ? `top${data.serverRank}` : `grade${data.grade}`;
    const gradeStr = (data.grade <= 0) ? '-' : '&nbsp;';

    const tpl = `<tr>
      <td class="rank"><span class="num">${data.rank}</span><span class="ui-rank ${data.rankUpDown}">${data.rankChange}</span></td>
      <td>${data.characterName}</td>
      <td>${data.className}</td>
      <td class="grade"><span class="star ${gradeIcon}">${gradeStr}</span></td>
    </tr>`;

    return tpl;
  }

  getRankChangeObj(number) {
    let obj = {change: '-', updown: ''};

    if (number > 0) {
      obj.change = number;
      obj.updown = 'up';

    } else if (number < 0) {
      obj.change = number;
      obj.updown = 'down';
    }

    return obj;
  }

  getRankUpDownStr(number) {
    let str = '';

    if (number > 0) {
      str = 'up';

    } else if (number < 0) {
      str = 'down';
    }

    return str;
  }

  getPaginationTpl(data) {
    const DISABLED_STR = `disabled="disabled"`;

    let prevBtn = `<button class="btn prev" ${(!data.previous) ? DISABLED_STR : ''}>이전</button>`,
      pageBtns = `<span class="page">
                    <strong>${data.start}-${data.end}</strong> / ${data.totalCount}
                  </span>`,
      nextBtn = `<button class="btn next" ${(!data.next) ? DISABLED_STR : ''}>다음</button>`;

    return `${prevBtn}${pageBtns}${nextBtn}`;
  }

  setLoadingBar(flag) {
    const _ = this;

    if (truthy(flag)) {
      $('.table-list', _.wrap).append(getLoadingBarTpl());

    } else {
      $('.loadingbar', _.wrap).remove();
    }
  }

  displayError(code) {
    const _ = this;

    $('.table-list', _.wrap).hide();
    $('.pagination', _.wrap).hide();

    switch (code) {
      case 'NO_ITEM' :
        _.wrap.append(`<div class="nodata"><p>${_.msg.NO_ITEM}</p></div>`);
        break;

      case 'RETRY_LATER' :
        _.wrap.append(`<div class="nodata"><p>${BOARD.RETRY_LATER}</p></div>`);
        break;

      case 'NO_SUPPORT' :
        _.wrap.append(`<div class="nodata"><p>${_.msg.NO_SUPPORT}</p></div>`);
        break;

    }
  }
}

export default ClassRanking;


// WEBPACK FOOTER //
// ./_src/js/world/ranking/ClassRanking.js